/**
 * Lifecycle hook-point for mission status transitions.
 *
 * State machine (set by the store actions called below):
 *   draft        -> pending_approval   : "Send to operator" button
 *   pending_approval -> scheduled      : operator webhook (NOT wired yet)
 *   scheduled    -> in_flight          : operator webhook (NOT wired yet)
 *   in_flight    -> completed          : telemetry stream ends (closeLiveView)
 *   ANY          -> draft              : "Cancel dispatch" button
 *
 * The previous demo-only 1-Hz timer that auto-advanced pending_approval →
 * scheduled (after 10 s) and scheduled → in_flight (after another 20 s) has
 * been removed. Those transitions are now operator-driven via the fleet-
 * software webhook — this component is kept as the mountpoint where that
 * webhook subscription will live.
 *
 * Mounted at EditorPage level — returns null.
 */

export default function MissionFlowController() {
  // Future: subscribe to operator webhook events here and call
  // useDockDemoStore.getState().setMissionFlowState(missionId, nextState).
  // Webhook payload would carry the missionId (matched against `sentAt`'s
  // tokenized share link) plus the new state + optional scheduledStartAt.
  return null;
}
